'use strict';

var cov_l8th63m9h = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\account\\account.js',
      hash = 'ab38c86f39ffd2e4c1cc5b27d7a44fc8de81e522',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\account\\account.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 54
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 30
        }
      },
      '2': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 34
        }
      },
      '3': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 20,
          column: 6
        }
      },
      '4': {
        start: {
          line: 9,
          column: 22
        },
        end: {
          line: 14,
          column: 24
        }
      },
      '5': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 19,
          column: 9
        }
      },
      '6': {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 21
        }
      },
      '7': {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 45
        }
      },
      '8': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 35,
          column: 6
        }
      },
      '9': {
        start: {
          line: 23,
          column: 22
        },
        end: {
          line: 28,
          column: 24
        }
      },
      '10': {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 34,
          column: 9
        }
      },
      '11': {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 25
        }
      },
      '12': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 59
        }
      },
      '13': {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 45
        }
      },
      '14': {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 41,
          column: 6
        }
      },
      '15': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 40,
          column: 9
        }
      },
      '16': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 48
        }
      },
      '17': {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 47,
          column: 6
        }
      },
      '18': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 9
        }
      },
      '19': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 48
        }
      },
      '20': {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 56,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 98
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 8,
            column: 30
          },
          end: {
            line: 8,
            column: 31
          }
        },
        loc: {
          start: {
            line: 8,
            column: 44
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 8
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 15,
            column: 35
          },
          end: {
            line: 15,
            column: 36
          }
        },
        loc: {
          start: {
            line: 15,
            column: 41
          },
          end: {
            line: 17,
            column: 7
          }
        },
        line: 15
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 10
          }
        },
        loc: {
          start: {
            line: 17,
            column: 15
          },
          end: {
            line: 19,
            column: 7
          }
        },
        line: 17
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 22,
            column: 26
          },
          end: {
            line: 22,
            column: 27
          }
        },
        loc: {
          start: {
            line: 22,
            column: 40
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 22
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 29,
            column: 35
          },
          end: {
            line: 29,
            column: 36
          }
        },
        loc: {
          start: {
            line: 29,
            column: 41
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 29
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 10
          }
        },
        loc: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 34,
            column: 7
          }
        },
        line: 32
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 37,
            column: 21
          }
        },
        loc: {
          start: {
            line: 37,
            column: 32
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 37
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 38,
            column: 70
          },
          end: {
            line: 38,
            column: 71
          }
        },
        loc: {
          start: {
            line: 38,
            column: 81
          },
          end: {
            line: 40,
            column: 7
          }
        },
        line: 38
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 43,
            column: 17
          },
          end: {
            line: 43,
            column: 18
          }
        },
        loc: {
          start: {
            line: 43,
            column: 29
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 43
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 44,
            column: 67
          },
          end: {
            line: 44,
            column: 68
          }
        },
        loc: {
          start: {
            line: 44,
            column: 78
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 44
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountController =
/** @ngInject */
function AccountController($scope, $http, $rootScope, $mdDialog, $state, myVars, $window, localStorageService) {
  _classCallCheck(this, AccountController);

  ++cov_l8th63m9h.f[0];
  ++cov_l8th63m9h.s[0];

  myVars.login = localStorageService.get('islogin');
  ++cov_l8th63m9h.s[1];
  $scope.checkinfo = myVars;
  ++cov_l8th63m9h.s[2];
  console.log($scope.checkinfo);

  ++cov_l8th63m9h.s[3];
  $scope.showCancelDialog = function (ev) {
    ++cov_l8th63m9h.f[1];

    var confirm = (++cov_l8th63m9h.s[4], $mdDialog.confirm().title('Quý khách có muốn hủy DV VT Lì xì? ').textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    ++cov_l8th63m9h.s[5];
    $mdDialog.show(confirm).then(function () {
      ++cov_l8th63m9h.f[2];
      ++cov_l8th63m9h.s[6];

      $scope.huy();
    }, function () {
      ++cov_l8th63m9h.f[3];
      ++cov_l8th63m9h.s[7];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_l8th63m9h.s[8];
  $scope.showDkDialog = function (ev) {
    ++cov_l8th63m9h.f[4];

    var confirm = (++cov_l8th63m9h.s[9], $mdDialog.confirm().title('Bạn có chắc chắn muốn đăng ký dịch vụ ').textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    ++cov_l8th63m9h.s[10];
    $mdDialog.show(confirm).then(function () {
      ++cov_l8th63m9h.f[5];

      var data = (++cov_l8th63m9h.s[11], true);
      ++cov_l8th63m9h.s[12];
      $rootScope.$emit('CallMethodRegister', { ev: ev, data: data });
    }, function () {
      ++cov_l8th63m9h.f[6];
      ++cov_l8th63m9h.s[13];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_l8th63m9h.s[14];
  $scope.dangky = function () {
    ++cov_l8th63m9h.f[7];
    ++cov_l8th63m9h.s[15];

    $http.post($rootScope.apiOpen + 'dangky/' + myVars.msisdn).then(function (results) {
      ++cov_l8th63m9h.f[8];
      ++cov_l8th63m9h.s[16];

      $window.location = results.data.message;
    });
  };

  ++cov_l8th63m9h.s[17];
  $scope.huy = function () {
    ++cov_l8th63m9h.f[9];
    ++cov_l8th63m9h.s[18];

    $http.post($rootScope.apiOpen + 'huy/' + myVars.msisdn).then(function (results) {
      ++cov_l8th63m9h.f[10];
      ++cov_l8th63m9h.s[19];

      $window.location = results.data.message;
    });
  };
};

++cov_l8th63m9h.s[20];


angular.module('app').component('account', {
  templateUrl: 'app/account/account.html',
  controller: AccountController
});